import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Plus, Check } from 'lucide-react';
import { ServiceItem } from '../types';

interface ServiceCardProps {
  service: ServiceItem;
  isSelected: boolean;
  onToggle: () => void;
  index?: number;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ 
  service, 
  isSelected, 
  onToggle,
  index = 0 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: index * 0.05 }}
      className={`p-4 rounded-xl border-2 transition-all cursor-pointer ${
        isSelected 
          ? 'border-primary bg-primary-light/50' 
          : 'border-gray-100 bg-white hover:border-gray-200'
      }`}
      onClick={onToggle}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <h4 className="font-medium text-prim-text mb-1 line-clamp-1">
            {service.name}
          </h4>
          
          {service.description && (
            <p className="text-sm text-gray-500 mb-2 line-clamp-2">
              {service.description}
            </p>
          )}
          
          <div className="flex items-center text-sm text-gray-500">
            <Clock size={14} className="mr-1" />
            <span>{service.duration} mins</span>
          </div>
        </div>

        <div className="flex flex-col items-end ml-4">
          <span className="font-semibold text-lg text-primary mb-2">
            £{service.price.toFixed(2)}
          </span>
          
          <button
            className={`w-8 h-8 rounded-full flex items-center justify-center transition-all ${
              isSelected 
                ? 'bg-primary text-white' 
                : 'bg-gray-100 text-gray-600 hover:bg-primary hover:text-white'
            }`}
          >
            {isSelected ? <Check size={18} /> : <Plus size={18} />}
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default ServiceCard;

